import { api } from "..";
import { QueryProps } from "@/types/Api";

export interface UserBettingRules {
  minStakeAmount: number;
  maxStakeAmount: number;
  maxPayoutAmount: number;
  minSelectionsCount: number;
  maxSelectionsCount: number;
  maxTotalOdds: number;
  lineMinOdds: number;
  lineMaxOdds: number;
  liveMinOdds: number;
  liveMaxOdds: number;
  liveBettingDelaySeconds: number;
  /** Live matches past this minute are locked or hidden per matchRemovalAction. */
  matchRemovalMinute: number | null;
  matchRemovalAction: "lock" | "hide" | null;
  systemBetsEnabled: boolean;
  combinationBoostEnabled: boolean;
  combinationInsuranceEnabled: boolean;
  mixLiveAndLineEnabled: boolean;
  // Per-sport combine rules. The unprefixed mixLiveAndLineEnabled above is
  // FOOTBALL. Per-feed on/off is the sport/feed switch, not a betting rule.
  basketballMixLiveAndLineEnabled: boolean;
  mixFootballAndBasketballEnabled: boolean;
  mixVirtualFootballAndOthersEnabled: boolean;
  mixVirtualBasketballAndOthersEnabled: boolean;
  oddsChangeAllowed: boolean;
  couponCancelWindowMinutes: number;
  allowSameEventSelections: boolean;
  // Optional so the panel tolerates a backend that does not send it yet.
  winProbabilityEnabled?: boolean;
  // Cash out, capped by every level above. Optional for the same reason.
  cashoutEnabled?: boolean;
  cashoutMarginPercent?: number;
  cashoutMaxAmount?: number;
  cashoutSingleEnabled?: boolean;
}

export async function getUserBettingRules(
  props: QueryProps
): Promise<UserBettingRules> {
  const res = await api.client.get("/betting-rules", {
    signal: props.signal,
  });
  return res.data;
}
